import {SharedStatusPageFormKeys} from "@/pages/statuspages/shared/StatusPage.types.ts";
import {ManageStatusPageUpdateFormTab} from "@/pages/statuspages/statuspages-manage/ManageStatusPageUpdateFormTab.tsx";
import {StatusPageGeneralDefaultValues} from "@/pages/statuspages/tabs/general/StatusPageGeneralTab.form.ts";
import {StatusPageGeneralTabV2} from "@/pages/statuspages/tabs/general/StatusPageGeneralTabV2.tsx";

import styles from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.module.scss";

export const ManageStatusPageGeneralTab = () => {
  const fields = Object.keys(StatusPageGeneralDefaultValues) as SharedStatusPageFormKeys[];

  return (
    <ManageStatusPageUpdateFormTab key={"general-v2"} fields={fields}>
      <StatusPageGeneralTabV2 variant={"edit"} className={styles.formTabContainer} />
    </ManageStatusPageUpdateFormTab>
  );
};
